import { Injectable } from '@angular/core';
import { ErrorModel } from '../Models/error.model';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private error: ErrorModel | null = null;
  constructor() {
  }
  setError(error: ErrorModel): void {
    this.error = error;
  }
  getError(): ErrorModel | null {
    const error = this.error;
    this.error = null;
    return error;
  }
}
